<div class="page-content container">
    <div class="page-header">
      <h1 class="page-title text-primary-d2">
        Campeonatos
        <small class="page-info text-secondary-d2">
          <i class="fa fa-angle-double-right text-80"></i>
          Lista
        </small>
      </h1>
    </div>

    

    <div class="bgc-primary-d1 text-white px-3 py-25">
        <div class="row">
          <div class="col-md-6 col-12">
            <span class="text-90">Lista de</span>
            Campeonatos
          </div>
          <div class="col-md-6 col-12">
            <div class="columns columns-right btn-group float-right">
              <button *ngIf="aplicacion.puede_crear" title="Nuevo" (click)="crearNuevoCampeonato()" class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1 bs-print" type="button">
                <i class="fa fa-plus text-purple-d1"></i>
              </button>
              <button *ngIf="aplicacion.puede_ver" class="btn btn-outline-warning btn-smd bgc-white btn-h-light-warning btn-a-outline-warning py-1 bs-print" type="button" (click)="abrirModalGeneracionPdfTarjetasJugador()">          
                <i class="fas fa-id-card text-105"></i>
              </button>
              <button *ngIf="aplicacion.puede_modificar" title="Jugadores duplicados" class="btn btn-outline-danger btn-smd bgc-white btn-h-light-danger btn-a-outline-danger py-1 bs-print" type="button" (click)="abrirJugadoresDuplicados()">
                <i class="fas fa-user-friends text-105"></i>
              </button>
              <div class="export btn-group">
                <button class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1 dropdown-toggle" type="button" data-toggle="dropdown" aria-label="Opciones" title="Acciones" aria-expanded="true">
                  <i class="fa fa-wrench text-blue-d1"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu dropdown-menu-right enable-columns-bar" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-137px, 37px, 0px);" x-placement="bottom-end">
                  <div class="col-12 col-sm-12 mt-12 mt-sm-0 cards-container">
                    <div class="card bgc-primary brc-primary radius-0">
                      <div class="card-header">
                      <h5 class="card-title text-white font-light"><i class="fa fa-table mr-2px"></i> Acciones</h5>
                      </div>
            
                      <div class="card-body p-0 bg-white">
                      <table class="table table-striped table-hover mb-0">
                        <tbody>
                          <tr>
                            <td class="text-dark-m2">
                            Configuración Aplicación
                            </td>
                            <td class="text-dark-m2">
                              <a (click)="abrirConfiguracionAplicacion()" href="javascript:void(0)" class="text-blue"><i class="fa fa-cog text-primary"></i></a>
                            </td>
                          </tr>
                          <tr *ngIf="usuario.empresa.usar_mensajeria_redes_sociales">
                            <td class="text-dark-m2">
                            Grupos Whatsapp
                            </td>
                            <td class="text-dark-m2">
                              <a (click)="abrirParticipantesGrupoWhatsapp()" href="javascript:void(0)" class="text-success"><i class="fas fa-user-friends text-purple-d1"></i></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="bootstrap-table bootstrap4">
      <div class="fixed-table-toolbar">
        <div class="row">
          <div class="col-12 col-md-9">
            <div class="row">
            <div class="col-12 col-md-12">
              <app-paginator-header [paginator]="this"></app-paginator-header>
            </div>
            </div>
		  </div>
          <div class="col-3 col-md-3">
            <div class="row">
              <div class="col-12">
                <button (click)="getSearch(text_search,null)" class="btn btn-xs btn-app btn-primary my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Buscar">
                  <i class="d-block h-4 fa fa fa-search text-150"></i>
                </button>
              </div>
            </div>
          </div>
		</div>
      </div>

      <div class="fixed-table-container" style="padding-bottom: 0px;">
        <div class="fixed-table-header" style="display: none;">
          <table></table>
        </div>
        <div id="gallery" class="fixed-table-body">
          <div class="fixed-table-loading table table-bordered table-hover" style="top: 46.6167px;">
            <span class="loading-wrap">
              <span class="animation-wrap">
                <span class="animation-dot"></span>
              </span>
            </span>
          </div>
          <!-- tabla-tarjetas: en el celular cada fila se ve como tarjeta (ver el css), los data-label son los titulos -->
          <table *ngIf="campeonatos.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive tabla-tarjetas" id="table">
            <thead class="bgc-white text-grey text-uppercase text-80">
              <tr>
                <th>N°</th>
                <th class="center"><a href="javascript:void(0)">Código <span id="codigo" class="sort fa fa-sort icon-only"></span></a></th>
                <th class="center"><a href="javascript:void(0)">Logo <span id="imagen" class="sort fa fa-sort icon-only"></span></a></th>
                <th class="center"><a href="javascript:void(0)">Nombre <span id="nombre" class="sort fa fa-sort icon-only"></span></a></th>
                <th class="center"><a href="javascript:void(0)">Fecha Inicio <span id="fecha_inicio" class="sort fa fa-sort icon-only"></span></a></th>
                <th class="center"><a href="javascript:void(0)">Fecha Fin <span id="fecha_inicio" class="sort fa fa-sort icon-only"></span></a></th>
                <th class="center"><a href="javascript:void(0)">Estado <span id="fecha_inicio" class="sort fa fa-sort icon-only"></span></a></th>
                <th style="text-align: center; width: 140px; " data-field="tools">
                  <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                  <div class="fht-cell"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr #campeonatos *ngFor="let campeonato of campeonatos; let i=index;">
                <td class="celda-numero">
                  {{(i+1)+(this.itemsPerPage*(this.currentPage-1))}}
                </td>
                <td class="celda-dato" data-label="Código">
                    {{campeonato.codigo}}
                </td>
                <td class="celda-logo">
                  <div class="imagen-campeonato-vista clearfix">
                      <a href="{{rest_server+campeonato.logo}}" title="{{campeonato.nombre}}" data-rel="colorbox">
                          <img width="50" height="50" alt="sin imagen" src="{{rest_server+campeonato.logo}}" />
                      </a>
                  </div>
              </td>
                <td class="celda-titulo">
                    {{campeonato.nombre}}
                </td>
                <td class="celda-dato" data-label="Fecha Inicio">
                    {{campeonato.fecha_inicio | date:"dd/MM/yyyy"}}
                </td>
                <td class="celda-dato" data-label="Fecha Fin">
                    {{campeonato.fecha_fin | date:"dd/MM/yyyy"}}
                </td>
                <td class="celda-dato" data-label="Estado" *ngIf="campeonato.activo"><span class="badge badge-sm badge-success">ACTIVO</span></td>
                <td class="celda-dato" data-label="Estado" *ngIf="!campeonato.activo"><span class="badge badge-sm badge-danger">INACTIVO</span></td>
                <td class="celda-acciones" style="text-align: center; width: 140px; ">
                  <div class="action-buttons">        
                    <a *ngIf="aplicacion.puede_ver" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="verSaldosClientes(campeonato)">          
                      <i class="fa fa-money-bill-alt text-105"></i>        
					          </a>
                    <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="modificarCampeonato(campeonato)">          
                      <i class="fa fa-pencil-alt text-105"></i>        
					          </a>
                    <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="verEquipos(campeonato)">          
                        <i class="fas fa-users-cog text-105"></i>        
                      </a>
                      <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="abrirModalConfiguracionTarjetaJugador(campeonato)">          
                        <i class="fas fa-id-card-alt text-105"></i>        
                      </a>
                    <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-purple btn-a-outline-purple btn-text-purple" href="javascript:void(0)" (click)="abrirModalConfiguracionPdfRolPartido(campeonato)">          
                      <i class="fas fa-images text-105"></i>        
                    </a>
                    <a *ngIf="aplicacion.puede_eliminar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacion(campeonato)">          
                      <i class="fa fa-trash-alt text-105"></i>        
                    </a>      
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="fixed-table-footer">
          <table><thead><tr></tr></thead></table>
        </div>
      </div>
      <div class="fixed-table-pagination">
        <app-paginator-footer *ngIf="campeonatos.length>0" class="pagination-detail" [paginator]="this"></app-paginator-footer>
      </div>
    </div>
    <div class="clearfix"></div>
</div>

<ng-template #modal_campeonato_modificacion let-modal>
    <div class="modal-header card-header">
        <div class="col-md-8 col-xs-8">
            <span class="text-blue text-125">Registro Campeonato</span>
        </div>
        <div class="col-md-6 col-xs-6">
            <button (click)="guardarCampeonato()" class="btn btn-primary"  >
                <i class="fa fa-save text-110 mr-1"></i>
            </button>&nbsp;
            <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 text-110 mr-1"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <label>Código</label>
            </div>
            <div class="col-sm-12 col-md-6">
                <input [disabled]="codigo_automatico" required type="text" id="codigo" name="codigo" [(ngModel)]="campeonato.codigo" placeholder="Código" class="form-control" />
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Nombre</label>
            </div>
            <div class="col-sm-12 col-md-9">
                <input name="nombre" required type="text" [(ngModel)]="campeonato.nombre" placeholder="Nombre" class="form-control" />
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Fecha Inicio</label>
            </div>
            <div class="col-sm-12 col-md-9">
                <div class="input-group">
                    <input name="fecha" class="form-control" placeholder="dd/mm/yyyy"
                            name="dp" [(ngModel)]="campeonato.fecha_inicio_texto" ngbDatepicker #d="ngbDatepicker">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                    </div>
                </div> 
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Fecha Fin</label>
            </div>
            <div class="col-sm-12 col-md-9">
                <div class="input-group">
                    <input name="fecha_f" class="form-control" placeholder="dd/mm/yyyy"
                            name="dp" [(ngModel)]="campeonato.fecha_fin_texto" ngbDatepicker #f="ngbDatepicker">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="f.toggle()" type="button"></button>
                    </div>
                </div> 
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Derecho Cancha</label>
            </div>
            <div class="col-sm-12 col-md-9">

              <ng-container *ngIf="campeonato.derecho_cancha && campeonato.derecho_cancha.id">
                <span class="m-1 bgc-blue-l3 border-1 brc-blue-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{campeonato.derecho_cancha.nombre}}</span><br>
              </ng-container>
              <input *ngIf="!campeonato.derecho_cancha" autocomplete="off" [(ngModel)]="producto_busqueda"
              [ngbTypeahead]="buscarProducto" placeholder="Buscar derecho Cancha" [resultTemplate]="rtp" name="producto_busqueda"
              [inputFormatter]="formatterProducto"  (selectItem)="establecerProducto($event)"
              type="text" class="form-control"/>

              <ng-template #rtp let-r="result" let-t="term">
                <img [src]="rest_server+r.imagen" class="mr-1" style="width: 16px">
                <ngb-highlight [result]="r.codigo+'-'+r.nombre+'-'+(r.grupo?r.grupo.nombre:'')+'-'+(r.subgrupo?r.subgrupo.nombre:'')" [term]="t"></ngb-highlight>
              </ng-template>

              <a href="javascript:void(0)" *ngIf="campeonato.derecho_cancha && campeonato.derecho_cancha.id" (click)="iniciarDerechoCancha()" class="card-toolbar-btn text-danger-m1">
                  <i class="ace-icon fa fa-trash bigger-130"></i>
              </a>
            </div>
        </div>
        <hr>
        <!-- arbitraje por disciplina: cada partido cobra el producto de su disciplina; las que no esten aca cobran el derecho de cancha de arriba -->
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Arbitraje por disciplina</label>
            </div>
            <div class="col-sm-12 col-md-9">
              <div class="d-flex flex-wrap align-items-center" *ngFor="let arbitraje of campeonato.arbitrajes; let i=index">
                <span class="m-1 bgc-grey-l3 border-1 brc-grey-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{arbitraje.disciplina?.nombre}}</span>
                <span class="m-1 bgc-blue-l3 border-1 brc-blue-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{arbitraje.producto?.nombre}} · Bs {{arbitraje.producto?.precio_unitario}}</span>
                <a href="javascript:void(0)" (click)="quitarArbitraje(i)" class="card-toolbar-btn text-danger-m1">
                    <i class="ace-icon fa fa-trash bigger-130"></i>
                </a>
              </div>
              <div class="row mt-1">
                <div class="col-sm-12 col-md-5">
                  <select class="form-control" name="arbitraje_disciplina" [(ngModel)]="arbitraje_nuevo.disciplina">
                    <option [ngValue]="null">Disciplina...</option>
                    <option *ngFor="let disciplina of disciplinasSinArbitraje()" [ngValue]="disciplina">{{disciplina.nombre}}</option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-7">
                  <input autocomplete="off" [(ngModel)]="arbitraje_busqueda" [ngbTypeahead]="buscarProducto" placeholder="Buscar producto de arbitraje"
                    [resultTemplate]="rtp" name="arbitraje_busqueda" [inputFormatter]="formatterProducto" (selectItem)="agregarArbitraje($event)"
                    type="text" class="form-control"/>
                </div>
              </div>
              <small class="text-muted">Las disciplinas sin producto propio cobran el derecho de cancha.</small>
            </div>
        </div>
        <hr>
        <!-- reglas de juego por disciplina y categoria: las usa la planilla de la app (cronometro y sets de voleibol) -->
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Reglas de juego</label>
            </div>
            <div class="col-sm-12 col-md-9">
              <div class="d-flex flex-wrap align-items-center" *ngFor="let regla of campeonato.reglas; let i=index">
                <span class="m-1 bgc-grey-l3 border-1 brc-grey-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{nombreClase(tipo_disciplina,regla.id_disciplina)}}</span>
                <span class="m-1 bgc-grey-l3 border-1 brc-grey-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{regla.id_categoria?nombreClase(tipo_categoria,regla.id_categoria):'Todas las categorías'}}</span>
                <span class="m-1 bgc-blue-l3 border-1 brc-blue-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{textoRegla(regla)}}</span>
                <a href="javascript:void(0)" (click)="quitarRegla(i)" class="card-toolbar-btn text-danger-m1">
                    <i class="ace-icon fa fa-trash bigger-130"></i>
                </a>
              </div>
              <!-- en dos filas: disciplina y categoria arriba; los minutos (o los puntos) y el boton abajo, con lugar para leer lo escrito -->
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <select class="form-control" name="regla_disciplina" [(ngModel)]="regla_nueva.disciplina">
                    <option [ngValue]="null">Disciplina...</option>
                    <option *ngFor="let disciplina of tipo_disciplina?.clases" [ngValue]="disciplina">{{disciplina.nombre}}</option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-6">
                  <select class="form-control" name="regla_categoria" [(ngModel)]="regla_nueva.categoria">
                    <option [ngValue]="null">Todas las categorías</option>
                    <option *ngFor="let categoria of tipo_categoria?.clases" [ngValue]="categoria">{{categoria.nombre}}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-1 align-items-center">
                <div class="col-sm-12 col-md-8">
                  <div class="d-flex flex-wrap align-items-center" *ngIf="regla_nueva.disciplina && tipoReglaDe(regla_nueva.disciplina)!='VOLEIBOL'">
                    <span class="mr-2">{{tipoReglaDe(regla_nueva.disciplina)=='BALONCESTO'?'4 cuartos de':'2 tiempos de'}}</span>
                    <input type="number" min="1" class="form-control text-center" style="width: 6rem" name="regla_minutos" [(ngModel)]="regla_nueva.minutos_periodo" placeholder="20">
                    <span class="ml-2">minutos</span>
                  </div>
                  <div class="d-flex flex-wrap align-items-center" *ngIf="regla_nueva.disciplina && tipoReglaDe(regla_nueva.disciplina)=='VOLEIBOL'">
                    <span class="mr-2">Al mejor de 3 · sets a</span>
                    <input type="number" min="1" class="form-control text-center" style="width: 6rem" name="regla_puntos_set" [(ngModel)]="regla_nueva.puntos_set">
                    <span class="mx-2">y el 3º a</span>
                    <input type="number" min="1" class="form-control text-center" style="width: 6rem" name="regla_puntos_decisivo" [(ngModel)]="regla_nueva.puntos_set_decisivo">
                    <span class="ml-2">puntos</span>
                  </div>
                  <small class="text-muted" *ngIf="!regla_nueva.disciplina">Elegí la disciplina para cargar los minutos o los puntos.</small>
                </div>
                <div class="col-sm-12 col-md-4">
                  <button type="button" class="btn btn-outline-primary btn-block" (click)="agregarRegla()">Agregar regla</button>
                </div>
              </div>
              <small class="text-muted">Sin regla, la planilla usa 2 tiempos de 20' (fútbol de salón), 4 cuartos de 10' (baloncesto) y, en voleibol, al mejor de 3 con sets a 25 y el 3º a 15. Una regla de una categoría gana sobre la de "Todas".</small>
            </div>
        </div>
        <hr>
        <!-- con esto, al dar de alta un equipo se puede cobrar la inscripcion sin pasar por Ventas -->
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <label>Inscripción</label>
            </div>
            <div class="col-sm-12 col-md-6">
              <ng-container *ngIf="campeonato.producto_inscripcion && campeonato.producto_inscripcion.id">
                <span class="m-1 bgc-blue-l3 border-1 brc-blue-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{campeonato.producto_inscripcion.nombre}}</span>
                <a href="javascript:void(0)" (click)="iniciarProductoInscripcion()" class="card-toolbar-btn text-danger-m1">
                    <i class="ace-icon fa fa-trash bigger-130"></i>
                </a>
              </ng-container>
              <input *ngIf="!campeonato.producto_inscripcion" autocomplete="off" [(ngModel)]="producto_inscripcion_busqueda"
                [ngbTypeahead]="buscarProducto" placeholder="Buscar producto de inscripción" [resultTemplate]="rtpi" name="producto_inscripcion_busqueda"
                [inputFormatter]="formatterProducto" (selectItem)="establecerProductoInscripcion($event)"
                type="text" class="form-control"/>
              <ng-template #rtpi let-r="result" let-t="term">
                <img [src]="rest_server+r.imagen" class="mr-1" style="width: 16px">
                <ngb-highlight [result]="r.codigo+'-'+r.nombre" [term]="t"></ngb-highlight>
              </ng-template>
            </div>
            <div class="col-sm-12 col-md-3">
              <input type="number" min="0" step="0.01" name="monto_inscripcion" [(ngModel)]="campeonato.monto_inscripcion"
                     class="form-control" placeholder="Monto sugerido" />
              <div class="text-grey text-85">Se puede cambiar en cada equipo</div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-12 col-md-1">
                <label>Logo</label>
            </div>
            <div class="col-sm-12 col-md-3">
                <form id="dropzone" action="/upload" class="dropzone bgc-white brc-dark-l3 brc-h-primary-m4 bgc-h-primary-l4 radius-1 mt-3">
                    <div class="fallback d-none">
                      <input name="file" type="file" multiple (change)="subirArchivo($event)"/>
                    </div>
    
                    <div class="dz-default dz-message">
                      <span class="text-150  text-grey-d2">
                      <span class="text-130 font-bolder"><i class="fa fa-caret-right text-danger-m1"></i> Arrastra archivos</span>
                      para subir
                      <span class="text-90 text-grey-m1">(o click)</span>
                      <br />
                      <i class="upload-icon fas fa-cloud-upload-alt text-blue-m1 fa-3x mt-4"></i>
                      </span>
                    </div>
                  </form>
    
                  <!-- the `html` of this element will be used by dropzone instance for previewing files/images -->
                  <div id="preview-template" class="d-none">
                    <div class="dz-preview dz-file-preview">
                      <div class="dz-image">
                        <img alt="Archivo" data-dz-thumbnail="" />
                      </div>
    
                      <div class="dz-details">
                        <div class="dz-size">
                          <span data-dz-size=""></span>
                        </div>
    
                        <div class="dz-filename">
                          <span data-dz-name=""></span>
                        </div>
                      </div>
    
                      <div class="dz-progress progress border-1 brc-yellow-tp2" style="height: 0.75rem;">
                        <div class="progress-bar bgc-success dz-upload " role="progressbar" data-dz-uploadprogress=""></div>
                      </div>
    
                      <div class="dz-error-message">
                        <span data-dz-errormessage=""></span>
                      </div>
    
                      <div class="dz-success-mark">
                        <span class="fa-stack fa-lg text-150">
                          <i class="fa fa-circle fa-stack-2x text-white"></i>
                          <i class="fa fa-check fa-stack-1x fa-inverse text-success-m1"></i>
                      </span>
                      </div>
    
                      <div class="dz-error-mark">
                        <span class="fa-stack fa-lg text-150">
                          <i class="fa fa-circle fa-stack-2x text-danger-m3"></i>
                          <i class="fas fa-exclamation fa-stack-1x fa-inverse text-white"></i>
                      </span>
                      </div>
                    </div>
                  </div>
            </div>
            <div class="col-sm-12 col-md-1">
              <label>Fondo Tabla Posiciones</label>
            </div>
            <div class="col-sm-12 col-md-3">
                <form id="fondo-tabla" action="/upload" class="dropzone bgc-white brc-dark-l3 brc-h-primary-m4 bgc-h-primary-l4 radius-1 mt-3">
                    <div class="fallback d-none">
                      <input name="file" type="file" multiple (change)="subirArchivo($event)"/>
                    </div>
    
                    <div class="dz-default dz-message">
                      <span class="text-150  text-grey-d2">
                      <span class="text-130 font-bolder"><i class="fa fa-caret-right text-danger-m1"></i> Arrastra archivos</span>
                      para subir
                      <span class="text-90 text-grey-m1">(o click)</span>
                      <br />
                      <i class="upload-icon fas fa-cloud-upload-alt text-blue-m1 fa-3x mt-4"></i>
                      </span>
                    </div>
                  </form>
    
                  <!-- the `html` of this element will be used by dropzone instance for previewing files/images -->
                  <div id="fondo-tabla-template" class="d-none">
                    <div class="dz-preview dz-file-preview">
                      <div class="dz-image">
                        <img alt="Archivo" data-dz-thumbnail="" />
                      </div>
    
                      <div class="dz-details">
                        <div class="dz-size">
                          <span data-dz-size=""></span>
                        </div>
    
                        <div class="dz-filename">
                          <span data-dz-name=""></span>
                        </div>
                      </div>
    
                      <div class="dz-progress progress border-1 brc-yellow-tp2" style="height: 0.75rem;">
                        <div class="progress-bar bgc-success dz-upload " role="progressbar" data-dz-uploadprogress=""></div>
                      </div>
    
                      <div class="dz-error-message">
                        <span data-dz-errormessage=""></span>
                      </div>
    
                      <div class="dz-success-mark">
                        <span class="fa-stack fa-lg text-150">
                          <i class="fa fa-circle fa-stack-2x text-white"></i>
                          <i class="fa fa-check fa-stack-1x fa-inverse text-success-m1"></i>
                      </span>
                      </div>
    
                      <div class="dz-error-mark">
                        <span class="fa-stack fa-lg text-150">
                          <i class="fa fa-circle fa-stack-2x text-danger-m3"></i>
                          <i class="fas fa-exclamation fa-stack-1x fa-inverse text-white"></i>
                      </span>
                      </div>
                    </div>
                  </div>
            </div>
            <div class="col-sm-12 col-md-1">
              <label>Fondo Rol Partido</label>
            </div>
            <div class="col-sm-12 col-md-3">
              <form id="fondo-rol" action="/upload" class="dropzone bgc-white brc-dark-l3 brc-h-primary-m4 bgc-h-primary-l4 radius-1 mt-3">
                  <div class="fallback d-none">
                    <input name="file" type="file" multiple (change)="subirArchivoRol($event)"/>
                  </div>
  
                  <div class="dz-default dz-message">
                    <span class="text-150  text-grey-d2">
                    <span class="text-130 font-bolder"><i class="fa fa-caret-right text-danger-m1"></i> Arrastra archivos</span>
                    para subir
                    <span class="text-90 text-grey-m1">(o click)</span>
                    <br />
                    <i class="upload-icon fas fa-cloud-upload-alt text-blue-m1 fa-3x mt-4"></i>
                    </span>
                  </div>
                </form>
  
                <!-- the `html` of this element will be used by dropzone instance for previewing files/images -->
                <div id="fondo-rol-template" class="d-none">
                  <div class="dz-preview dz-file-preview">
                    <div class="dz-image">
                      <img alt="Archivo" data-dz-thumbnail="" />
                    </div>
  
                    <div class="dz-details">
                      <div class="dz-size">
                        <span data-dz-size=""></span>
                      </div>
  
                      <div class="dz-filename">
                        <span data-dz-name=""></span>
                      </div>
                    </div>
  
                    <div class="dz-progress progress border-1 brc-yellow-tp2" style="height: 0.75rem;">
                      <div class="progress-bar bgc-success dz-upload " role="progressbar" data-dz-uploadprogress=""></div>
                    </div>
  
                    <div class="dz-error-message">
                      <span data-dz-errormessage=""></span>
                    </div>
  
                    <div class="dz-success-mark">
                      <span class="fa-stack fa-lg text-150">
                        <i class="fa fa-circle fa-stack-2x text-white"></i>
                        <i class="fa fa-check fa-stack-1x fa-inverse text-success-m1"></i>
                    </span>
                    </div>
  
                    <div class="dz-error-mark">
                      <span class="fa-stack fa-lg text-150">
                        <i class="fa fa-circle fa-stack-2x text-danger-m3"></i>
                        <i class="fas fa-exclamation fa-stack-1x fa-inverse text-white"></i>
                    </span>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #modal_lista_equipos let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">{{campeonato.nombre}}: Lista de Equipos</span>
      </div>
      <div class="col-md-6 col-xs-6">
          <button (click)="crearNuevoEquipo(campeonato)" class="btn btn-success"  >
              <i class="fa fa-plus text-110 mr-1"></i>
          </button>&nbsp;
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row">
          <div class="col-12">

            <div class="card bcard bgc-transparent shadow-none">
                <div class="card-body p-0">
                    <ul class="nav nav-tabs align-self-start pestanas-categorias" role="tablist">
                    <!-- el orden lo arma el componente, para que TODOS quede siempre primero -->
                    <li class="nav-item brc-primary shadow-sm" *ngFor="let categoria of equipos">
                        <a (click)="establecerCategoriaTab(categoria)" [ngClass]="{'active':(categoria_tab.id==categoria.id)}" class="nav-link text-left py-3" id="{{categoria.id}}" data-toggle="tab" href="#{{categoria.id}}-" role="tab" aria-controls="home14" aria-selected="true">
                            {{categoria.nombre}}
                            <span class="conteo-pestana" [ngClass]="{
                                    'conteo-verde': categoria.listaEquipos.length > 4,
                                    'conteo-amarillo': categoria.listaEquipos.length === 4,
                                    'conteo-rojo': categoria.listaEquipos.length < 4
                                  }">{{categoria.listaEquipos.length}}</span>
                            <!-- la disciplina va debajo, con su color, porque una misma categoria
                                 aparece en varias disciplinas y las pestañas se veian repetidas -->
                            <span class="disciplina-pestana" [style.color]="categoria.color_disciplina">
                              {{categoria.disciplina}}
                            </span>
                        </a>
                    </li>
                    </ul>
        
                    <div class="tab-content p-35 border-1 brc-grey-l1 shadow-sm bgc-white contenido-equipos">
                        <div *ngFor="let categoria of equipos" [ngClass]="{'active':(categoria_tab.id==categoria.id)}" class="tab-pane fade show text-95" id="{{categoria.id}}-" role="tabpanel" aria-labelledby="{{categoria.id}}">
                            <div class="row">
                                <div class="col-12 col-md-12 p-1">
                                    <div class="card bcard overflow-hidden shadow marco-equipos">
                                    <div class="card-body p-3px bgc-primary-d2">
                                        <div class="radius-1 table-responsive">

                                          <!-- tabla-tarjetas: en el celular cada equipo se ve como tarjeta; del encabezado solo queda el switch general -->
                                          <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive tabla-tarjetas" id="table">
                                            <thead class="bgc-white text-grey text-uppercase text-80">
                                              <tr>
                                                <th>N°</th>
                                                <th class="center th-celular th-habilitar-todos">
                                                  <a href="javascript:void(0)">¿Habilitar Jugadores? 
                                                    <span id="publicar_panel" class="sort fa fa-sort icon-only"></span>
                                                  </a>
                                                  <label>
                                                    <input [disabled]="!aplicacion.puede_modificar" (change)="actualizarAtributoEquipo(null,'habilitar_jugadores',tabla_equipo_general.habilitar_jugadores)" name="switch-field-1" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="tabla_equipo_general.habilitar_jugadores"/>
                                                  </label>
                                                </th>
                                                <th class="center">Código</th>
                                                <th class="center">Logo</th>
                                                <th class="center">Equipo</th>
                                                <th class="center">Cliente</th>
                                                <th class="center">Disciplina</th>
                                                <th class="center">Nivel</th>
                                                <th class="center">Categoria</th>
                                                <th style="text-align: center; width: 140px; " data-field="tools">
                                                  <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                                                  <div class="fht-cell"></div>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr #campeonatos *ngFor="let equipo of categoria.listaEquipos; let i=index;" [ngClass]="{'equipo-dado-baja':!equipo.activo}">
                                                <td class="celda-numero">
                                                  {{(i+1)}}
                                                </td>
                                                <td class="celda-switch" data-label="Habilitar jugadores">
                                                  <label>
                                                    <input [disabled]="!aplicacion.puede_modificar" (change)="actualizarAtributoEquipo(equipo,'habilitar_jugadores',equipo.habilitar_jugadores)" name="switch-field-1" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="equipo.habilitar_jugadores"/>
                                                  </label>
                                                </td>
                                                <td class="celda-dato" data-label="Código">
                                                    {{equipo.codigo}}
                                                </td>
                                                <td class="celda-logo">
                                                  <img width="50" height="50" alt="sin imagen" src="{{rest_server+equipo.logo}}" />
                                                </td>
                                                <td class="celda-titulo">
                                                    {{equipo.nombre}}
                                                    <span *ngIf="!equipo.activo" class="badge-equipo-baja">RETIRADO</span>
                                                    <!-- estado de la inscripcion: pagada, con saldo, o todavia sin cobrar -->
                                                    <ng-container *ngIf="campeonato.producto_inscripcion && campeonato.producto_inscripcion.id">
                                                      <span *ngIf="tieneInscripcionCobrada(equipo) && saldoInscripcion(equipo)<=0"
                                                            class="badge-inscripcion pagada" (click)="abrirInscripcionEquipo(equipo)"
                                                            [title]="'Nota de venta '+equipo.venta_inscripcion.factura+'. Click para cambiar el enlace'">INSCRITO</span>
                                                      <span *ngIf="tieneInscripcionCobrada(equipo) && saldoInscripcion(equipo)>0"
                                                            class="badge-inscripcion debe" (click)="abrirInscripcionEquipo(equipo)"
                                                            [title]="'Nota de venta '+equipo.venta_inscripcion.factura+' de '+equipo.venta_inscripcion.total+'. Click para cambiar el enlace'">
                                                        DEBE {{saldoInscripcion(equipo)}}
                                                      </span>
                                                      <span *ngIf="!tieneInscripcionCobrada(equipo)" class="badge-inscripcion sin-cobrar">SIN COBRAR</span>
                                                    </ng-container>
                                                </td>
                                                <td class="celda-dato" data-label="Cliente">
                                                  {{equipo.cliente.identificacion}}
                                              </td>
                                                <td class="celda-dato" data-label="Disciplina">
                                                    {{equipo.disciplina?equipo.disciplina.nombre:''}}
                                                </td>
                                                <td class="celda-dato" data-label="Nivel">
                                                  {{equipo.nivel.nombre}}
                                                </td>
                                                <td class="celda-dato" data-label="Categoría">
                                                  {{equipo.categoria.nombre}}
                                                </td>
                                                <td class="celda-acciones" style="text-align: center; width: 140px; ">
                                                  <div class="action-buttons">        
                                                    <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="modificarEquipo(equipo)">          
                                                      <i class="fa fa-pencil-alt text-105"></i>        
                                                    </a>
                                                    <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="verJugadores(equipo)">          
                                                        <i class="fas fa-walking text-105"></i>        
                                                      </a>
                                                    <a *ngIf="usuario.empresa.usar_mensajeria_redes_sociales" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" type="button" (click)="enviarPendientesEconomicosEquipo(equipo)">
                                                        <i class="fab fa-whatsapp red2 text-110"></i>
                                                    </a>
                                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" title="Copiar mensaje de deudas" (click)="copiarPendientesEconomicosEquipo(equipo)">
                                                      <i class="fas fa-clipboard text-105"></i>
                                                    </a>
                                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="copiarEnlace(equipo)">
                                                      <i class="fas fa-copy text-105"></i>
                                                    </a>
                                                    <!-- solo se ofrece el cobro si todavia no tiene inscripcion vigente -->
                                                    <a *ngIf="campeonato.producto_inscripcion && campeonato.producto_inscripcion.id && !tieneInscripcionCobrada(equipo)"
                                                       title="Cobrar inscripción"
                                                       class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success"
                                                       href="javascript:void(0)" (click)="abrirInscripcionEquipo(equipo)">
                                                      <i class="fas fa-file-invoice-dollar text-105"></i>
                                                    </a>
                                                    <a *ngIf="aplicacion.puede_eliminar && equipo.activo" title="Dar de baja al equipo" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionBajaEquipo(equipo)">
                                                      <i class="fas fa-user-slash text-105"></i>
                                                    </a>
                                                    <a *ngIf="aplicacion.puede_eliminar && !equipo.activo" title="Habilitar nuevamente al equipo" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="abrirPopupConfirmacionBajaEquipo(equipo)">
                                                      <i class="fas fa-undo text-105"></i>
                                                    </a>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>

                                        </div>
                                    </div>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--<table *ngIf="equipos.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
              <thead class="bgc-white text-grey text-uppercase text-80">
                <tr>
                  <th>N°</th>
                  <th class="center">
                    <a href="javascript:void(0)">¿Habilitar Jugadores? 
                      <span id="publicar_panel" class="sort fa fa-sort icon-only"></span>
                    </a>
                    <label>
                      <input [disabled]="!aplicacion.puede_modificar" (change)="actualizarAtributoEquipo(null,'habilitar_jugadores',tabla_equipo_general.habilitar_jugadores)" name="switch-field-1" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="tabla_equipo_general.habilitar_jugadores"/>
                    </label>
                  </th>
                  <th class="center">Código</th>
                  <th class="center">Logo</th>
                  <th class="center">Equipo</th>
                  <th class="center">Cliente</th>
                  <th class="center">Disciplina</th>
                  <th class="center">Nivel</th>
                  <th class="center">Categoria</th>
                  <th style="text-align: center; width: 140px; " data-field="tools">
                    <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                    <div class="fht-cell"></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr #campeonatos *ngFor="let equipo of equipos; let i=index;">
                  <td>
                    {{(i+1)}}
                  </td>
                  <td>
                    <label>
                      <input [disabled]="!aplicacion.puede_modificar" (change)="actualizarAtributoEquipo(equipo,'habilitar_jugadores',equipo.habilitar_jugadores)" name="switch-field-1" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="equipo.habilitar_jugadores"/>
                    </label>
                  </td>
                  <td>
                      {{equipo.codigo}}
                  </td>
                  <td >
                    <img width="50" height="50" alt="sin imagen" src="{{rest_server+equipo.logo}}" />
                  </td>
                  <td>
                      {{equipo.nombre}}
                  </td>
                  <td>
                    {{equipo.cliente.identificacion}}
                </td>
                  <td>
                      {{equipo.disciplina?equipo.disciplina.nombre:''}}
                  </td>
                  <td>
                    {{equipo.nivel.nombre}}
                  </td>
                  <td>
                    {{equipo.categoria.nombre}}
                  </td>
                  <td style="text-align: center; width: 140px; ">
                    <div class="action-buttons">        
                      <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="modificarEquipo(equipo)">          
                        <i class="fa fa-pencil-alt text-105"></i>        
                      </a>
                      <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="verJugadores(equipo)">          
                          <i class="fas fa-walking text-105"></i>        
                        </a>
                      <a *ngIf="usuario.empresa.usar_mensajeria_redes_sociales" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" type="button" (click)="enviarPendientesEconomicosEquipo(equipo)">
                          <i class="fab fa-whatsapp red2 text-110"></i>
                      </a>
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" title="Copiar mensaje de deudas" (click)="copiarPendientesEconomicosEquipo(equipo)">
                        <i class="fas fa-clipboard text-105"></i>
                      </a>
                      <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" (click)="copiarEnlace(equipo)">
                        <i class="fas fa-copy text-105"></i>
                      </a>
                      <a *ngIf="aplicacion.puede_eliminar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacion(campeonato)">          
                        <i class="fa fa-trash-alt text-105"></i>        
                      </a>      
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>-->
          </div>
      </div>
  </div>
</ng-template>

<ng-template #modal_equipo_modificacion let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Registro Equipo</span>
      </div>
      <div class="col-md-6 col-xs-6">
          <button (click)="guardarEquipo()" class="btn btn-primary"  >
              <i class="fa fa-save text-110 mr-1"></i>
          </button>&nbsp;
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row">
          <div class="col-sm-12 col-md-6">
              <label>Código</label>
          </div>
          <div class="col-sm-12 col-md-6">
              <input [disabled]="codigo_automatico" required type="text" id="codigo" name="codigo" [(ngModel)]="equipo.codigo" placeholder="Código" class="form-control" />
          </div>
      </div>
      <hr>
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Nombre</label>
          </div>
          <div class="col-sm-12 col-md-9">
              <input name="nombre" required type="text" [(ngModel)]="equipo.nombre" placeholder="Nombre" class="form-control" />
          </div>
      </div>
      <hr>
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Observación</label>
              <div class="text-grey text-90">Se muestra como aviso permanente en la matriz de cruces</div>
          </div>
          <div class="col-sm-12 col-md-9">
              <input name="observacion" type="text" maxlength="255" [(ngModel)]="equipo.observacion" placeholder="Sin observación" class="form-control" />
          </div>
      </div>
      <hr>
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Restricciones</label>
              <div class="text-grey text-90">El planificador semanal las respeta al programar</div>
          </div>
          <div class="col-sm-12 col-md-9">
              <div class="row mb-1" *ngFor="let restriccion of equipo.restricciones; let i=index;">
                  <div class="col-md-5">
                      <select class="form-control form-control-sm" [(ngModel)]="restriccion.tipo" [name]="'tipo_'+i">
                          <option value="DIA_NO">No jugar el día</option>
                          <option value="ESCENARIO_NO">No jugar en el escenario</option>
                          <option value="ESCENARIO_SI">Jugar solo en el escenario</option>
                          <option value="HORA_DESDE">Jugar recién desde la hora</option>
                          <option value="HORA_HASTA">Jugar solo hasta la hora</option>
                      </select>
                  </div>
                  <div class="col-md-5">
                      <select *ngIf="restriccion.tipo=='DIA_NO'" class="form-control form-control-sm"
                              [(ngModel)]="restriccion.dia" [name]="'dia_'+i">
                          <option [ngValue]="dia.dia" *ngFor="let dia of dias_semana">{{dia.nombre}}</option>
                      </select>
                      <select *ngIf="restriccion.tipo=='ESCENARIO_NO' || restriccion.tipo=='ESCENARIO_SI'"
                              class="form-control form-control-sm" [(ngModel)]="restriccion.id_escenario" [name]="'esc_'+i">
                          <option [ngValue]="escenario.id" *ngFor="let escenario of escenarios">{{escenario.nombre}}</option>
                      </select>
                      <div *ngIf="restriccion.tipo=='HORA_DESDE' || restriccion.tipo=='HORA_HASTA'" class="d-flex">
                          <input type="number" min="0" max="23" [(ngModel)]="restriccion.hora" [name]="'hora_'+i"
                                 class="form-control form-control-sm mr-1" placeholder="Hora" />
                          <input type="number" min="0" max="59" step="5" [(ngModel)]="restriccion.minuto" [name]="'min_'+i"
                                 class="form-control form-control-sm" placeholder="Min" />
                      </div>
                  </div>
                  <div class="col-md-2">
                      <a href="javascript:void(0)" (click)="quitarRestriccionEquipo(i)"
                         class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger">
                          <i class="fa fa-trash-alt"></i>
                      </a>
                  </div>
              </div>
              <button type="button" (click)="agregarRestriccionEquipo()" class="btn btn-sm btn-outline-primary">
                  <i class="fa fa-plus mr-1"></i>Agregar restricción
              </button>
          </div>
      </div>
      <hr>
      <ng-container *ngIf="cliente_registrado">
        <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Buscar Cliente</label>
          </div>
          <div class="col-sm-12 col-md-6">
            <ng-container *ngIf="equipo.cliente.id">
              <span class="m-1 bgc-blue-l3 border-1 brc-blue-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{equipo.cliente.razon_social}}</span><br>
              <span class="m-1 bgc-blue-l3 border-1 brc-blue-m3 text-dark-tp3 text-100 px-25 py-3px radius-round">{{equipo.cliente.identificacion}}</span>
            </ng-container>
            <input *ngIf="!equipo.cliente.id" name="cliente_razon_social" [inputFormatter]="formatter" [resultTemplate]="rt" 
            (selectItem)="establecerCliente($event)" type="text" class="form-control" autocomplete="off"
            [(ngModel)]="razon_busqueda" [ngbTypeahead]="buscarCliente" placeholder="Buscar cliente" />
            <ng-template #rt let-r="result" let-t="term">
              <ngb-highlight [result]="r.identificacion+' '+r.razon_social+' '+r.nit" [term]="t"></ngb-highlight>
            </ng-template>
          </div>
          <div class="col-sm-12 col-md-1">
            <a *ngIf="equipo.cliente.id" href="javascript:void(0)" (click)="abrirPopupRegistroRapidoCliente()" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success">
              <i class="fa fa-edit bigger-130"></i>
            </a>
            <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" *ngIf="equipo.cliente.id" (click)="reiniciarCliente()">
              <i class="fa fa-trash bigger-130 red2"></i>
            </a>
          </div>
          <div class="col-sm-12 col-md-1">
            <a (click)="cambiarClienteRegistrado()" href="javascript:void(0)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary">
              <i class="fas fa-exchange-alt"></i>
            </a>
          </div>
        </div>
        <hr>
      </ng-container>

      <ng-container *ngIf="!cliente_registrado">
        <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Representante</label>
          </div>
          <div class="col-sm-12 col-md-8">
              <input name="representante" required type="text" [(ngModel)]="equipo.cliente.razon_social" placeholder="Delegado" class="form-control" />
          </div>
          <div class="col-sm-12 col-md-1">
            <a (click)="cambiarClienteRegistrado()" href="javascript:void(0)" class="text-blue"><i class="fas fa-exchange-alt"></i></a>
          </div>
        </div>
        <hr>
      </ng-container>
      <div class="row">
        <div class="col-sm-12 col-md-3">
            <label>Teléfono Móvil</label>
        </div>
        <div class="col-sm-12 col-md-9">
            <input name="telefono movil" required type="text" [(ngModel)]="equipo.cliente.telefono1" placeholder="Teléfono Móvil" class="form-control" />
        </div>
      </div>
      <hr>
      <!-- al guardar se abre la venta con la inscripcion cargada, sin pasar por la pantalla de Ventas -->
      <div class="row" *ngIf="!equipo.id && campeonato.producto_inscripcion && campeonato.producto_inscripcion.id">
        <div class="col-sm-12 col-md-3">
            <label>Inscripción</label>
        </div>
        <div class="col-sm-12 col-md-9">
          <label class="mb-0">
            <input type="checkbox" name="cobrar_inscripcion" [(ngModel)]="equipo.cobrar_inscripcion" class="align-middle mr-1" />
            Cobrar al guardar: <b>{{campeonato.producto_inscripcion.nombre}}</b>
            <span *ngIf="campeonato.monto_inscripcion>0"> por {{campeonato.monto_inscripcion}} Bs</span>
          </label>
          <div class="text-grey text-85">Se abre la venta con el importe cargado; ahí se elige contado o crédito</div>
        </div>
      </div>
      <hr *ngIf="!equipo.id && campeonato.producto_inscripcion && campeonato.producto_inscripcion.id">
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Disciplina</label>
          </div>
          <div class="col-sm-12 col-md-7">
            <select [compareWith]="compararObjectos" class="form-control" required name="disciplina" [(ngModel)]="equipo.disciplina">
              <option [ngValue]="disciplina" *ngFor="let disciplina of tipo_disciplina.clases">{{disciplina.nombre}}</option>
            </select> 
          </div>
          <div class="col-sm-12 col-md-1">
            <span class="fa fa-edit point-edit blue" (click)="abrirConceptoEmpresa(global_variable.Dictionary.TIPO_EQUIPO_DISCIPLINAS,'obtenerDisciplinasEquiposEmpresa')"></span>
          </div>
      </div>
      <hr>
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Nivel</label>
          </div>
          <div class="col-sm-12 col-md-7">
            <select [compareWith]="compararObjectos" class="form-control" required name="nivel" [(ngModel)]="equipo.nivel">
              <option [ngValue]="nivel" *ngFor="let nivel of tipo_nivel.clases">{{nivel.nombre}}</option>
            </select> 
          </div>
          <div class="col-sm-12 col-md-1">
            <span class="fa fa-edit point-edit blue" (click)="abrirConceptoEmpresa(global_variable.Dictionary.TIPO_EQUIPO_NIVELES,'obtenerNivelesEquiposEmpresa')"></span>
          </div>
      </div>
      <hr>
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Categoría</label>
          </div>
          <div class="col-sm-12 col-md-7">
            <select [compareWith]="compararObjectos" class="form-control" required name="categoria" [(ngModel)]="equipo.categoria">
              <option [ngValue]="categoria" *ngFor="let categoria of tipo_categoria.clases">{{categoria.nombre}}</option>
            </select> 
          </div>
          <div class="col-sm-12 col-md-1">
            <span class="fa fa-edit point-edit blue" (click)="abrirConceptoEmpresa(global_variable.Dictionary.TIPO_EQUIPO_CATEGORIAS,'obtenerCategoriasEquiposEmpresa')"></span>
          </div>
      </div>
      <hr>
      <div class="row">
          <div class="col-sm-12 col-md-3">
              <label>Logo</label>
          </div>
          <div class="col-sm-12 col-md-9">
              <form id="logo-equipo" action="/upload" class="dropzone bgc-white brc-dark-l3 brc-h-primary-m4 bgc-h-primary-l4 radius-1 mt-3">
                  <div class="fallback d-none">
                    <input name="file" type="file" multiple (change)="subirArchivoLogo($event)"/>
                  </div>
  
                  <div class="dz-default dz-message">
                    <span class="text-150  text-grey-d2">
                    <span class="text-130 font-bolder"><i class="fa fa-caret-right text-danger-m1"></i> Arrastra archivos</span>
                    para subir
                    <span class="text-90 text-grey-m1">(o click)</span>
                    <br />
                    <i class="upload-icon fas fa-cloud-upload-alt text-blue-m1 fa-3x mt-4"></i>
                    </span>
                  </div>
                </form>
  
                <!-- the `html` of this element will be used by dropzone instance for previewing files/images -->
                <div id="preview-template-logo" class="d-none">
                  <div class="dz-preview dz-file-preview">
                    <div class="dz-image">
                      <img alt="Archivo" data-dz-thumbnail="" />
                    </div>
  
                    <div class="dz-details">
                      <div class="dz-size">
                        <span data-dz-size=""></span>
                      </div>
  
                      <div class="dz-filename">
                        <span data-dz-name=""></span>
                      </div>
                    </div>
  
                    <div class="dz-progress progress border-1 brc-yellow-tp2" style="height: 0.75rem;">
                      <div class="progress-bar bgc-success dz-upload " role="progressbar" data-dz-uploadprogress=""></div>
                    </div>
  
                    <div class="dz-error-message">
                      <span data-dz-errormessage=""></span>
                    </div>
  
                    <div class="dz-success-mark">
                      <span class="fa-stack fa-lg text-150">
                        <i class="fa fa-circle fa-stack-2x text-white"></i>
                        <i class="fa fa-check fa-stack-1x fa-inverse text-success-m1"></i>
                    </span>
                    </div>
  
                    <div class="dz-error-mark">
                      <span class="fa-stack fa-lg text-150">
                        <i class="fa fa-circle fa-stack-2x text-danger-m3"></i>
                        <i class="fas fa-exclamation fa-stack-1x fa-inverse text-white"></i>
                    </span>
                    </div>
                  </div>
                </div>
          </div>
      </div>
  </div>
</ng-template>

<ng-template #modal_lista_jugadores let-modal>
  <div class="modal-header card-header">
      <div class="col-7">
          <span class="text-blue text-125">{{equipo.nombre}}: Lista de Jugadores</span>
      </div>
      <div class="col-5">
          <button (click)="crearNuevoJugador(equipo)" class="btn btn-success"  >
              <i class="fa fa-plus text-110 mr-1"></i>
          </button>&nbsp;
          <button [disabled]="selectedItems.length==0" (click)="generarTarjetaIdentificacion(selectedItems)" class="btn btn-warning"  >
            <i class="fas fa-id-card text-110 mr-1"></i>
          </button>&nbsp;
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div class="row">
          <div class="col-12">
            <table *ngIf="jugadores.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
              <thead class="bgc-white text-grey text-uppercase text-80">
                <tr>
                  <th class="text-center pr-0">
                    <label class="py-0">
                      <input [(ngModel)]="allItemsSelected" (change)="selectAllItems(jugadores)" type="checkbox" class="align-bottom mb-n1 border-2 text-dark-m3" />
                    </label>
                  </th>
                  <th>N°</th>
                  <th class="center">Código</th>
                  <th class="center">Foto</th>
                  <th class="center">Nombre</th>
                  <th class="center">Posición</th>
                  <th style="text-align: center; width: 140px; " data-field="tools">
                    <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                    <div class="fht-cell"></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr #campeonatos *ngFor="let jugador of jugadores; let i=index;">
                  <td class='text-center pr-0 pos-rel'>
                    <div class="position-tl h-100 ml-n1px border-l-4 brc-orange-m1 v-hover">
                      <!-- border shown on hover -->
                    </div>
                    <div class="position-tl h-100 ml-n1px border-l-4 brc-success-m1">
                      <!-- border shown when row is selected -->
                    </div>
  
                    <label>
                      <input [(ngModel)]="jugador.selected" (change)="addItemToSelected(jugador.jugador)" type="checkbox" class="align-middle" />
                    </label>
                  </td>
                  <td>
                    {{i+1}}
                  </td>
                  <td>
                      {{jugador.jugador.codigo}}
                  </td>
                  <td >
                    <img width="50" height="50" alt="sin imagen" src="{{rest_server+jugador.jugador.persona.imagen}}" />
                  </td>
                  <td>
                      {{jugador.jugador.persona.nombre_completo}}
                  </td>
                  <td>
                      {{jugador.jugador.posicion}}
                  </td>
                  <td style="text-align: center; width: 140px; ">
                    <div class="action-buttons">        
                      <a *ngIf="aplicacion.puede_modificar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="modificarJugador(jugador.jugador)">          
                        <i class="fa fa-pencil-alt text-105"></i>        
                      </a>
                      <a *ngIf="aplicacion.puede_eliminar" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacionJugador(jugador)">          
                        <i class="fa fa-trash-alt text-105"></i>        
                      </a>      
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
  </div>
</ng-template>

<ng-template #modal_configuracion_tarjeta_jugador let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Configuración Tarjeta Jugador</span>
      </div>
      <div class="col-md-4 col-xs-4">
          <button (click)="guardarConfiguracionTarjetaJugador()" class="btn btn-primary"  >
              <i class="fa fa-save text-110 mr-1"></i>
          </button>&nbsp;
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
    <div class="row">
      <div class="col-2">Fondo</div>
      <div class="col-2">Titulo Liga</div>
      <div class="col-2">Tarjeta Jugador</div>
      <div class="col-2">Enunciados</div>
      <div class="col-2">Datos</div>
    </div>
    <div class="row">
      <div class="col-2">
        <input type="color" name="fondo_color_tarjeta" [(ngModel)]="campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta" class="form-control" />
      </div>
      <div class="col-2">
        <input type="color" name="titulo_color_liga" [(ngModel)]="campeonato.configuracion_tarjeta_jugador.titulo_color_liga" class="form-control" />
      </div>
      <div class="col-2">
        <input type="color" name="titulo_color_jugador" [(ngModel)]="campeonato.configuracion_tarjeta_jugador.titulo_color_jugador" class="form-control" />
      </div>
      <div class="col-2">
        <input type="color" name="enunciados_color" [(ngModel)]="campeonato.configuracion_tarjeta_jugador.enunciados_color" class="form-control" />
      </div>
      <div class="col-2">
        <input type="color" name="datos_color" [(ngModel)]="campeonato.configuracion_tarjeta_jugador.datos_color" class="form-control" />
      </div>
    </div>
    <hr>
    <div class="row p-3" [ngStyle]="{'background-color': campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta}">
      <div class="col-9">
        <label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.titulo_color_liga,'font-size.px': '30'}">{{usuario.empresa.nombre}}</label>
      </div>
      <div class="col-3">
        <img width="80" height="80" alt="sin imagen" src="{{usuario.empresa.imagen}}" />
      </div>
      <div class="col-12 text-center">
        <label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.titulo_color_jugador,'font-size.px': '25'}">TARJETA DE JUGADOR</label>
      </div>
      <div class="col-3">
        <img style="display:block; float: left;" width="100" height="100" alt="sin imagen" src="{{rest_server+'./img/icon-user-default.png'}}" />
      </div>
      <div class="col-9">
        <div class="row">
          <div class="col-4"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.enunciados_color,'font-size.px': '20'}">NOMBRE:</label></div>
          <div class="col-8"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.datos_color,'font-size.px': '20'}">JUAN PEREZ</label></div>
        </div>
        <div class="row">
          <div class="col-4"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.enunciados_color,'font-size.px': '20'}">EQUIPO:</label></div>
          <div class="col-8"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.datos_color,'font-size.px': '20'}">TU EQUIPO</label></div>
        </div>
        <div class="row">
          <div class="col-4"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.enunciados_color,'font-size.px': '20'}">CATEGORIA:</label></div>
          <div class="col-8"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.datos_color,'font-size.px': '20'}">SUB-10</label></div>
        </div>
        <div class="row">
          <div class="col-4"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.enunciados_color,'font-size.px': '20'}">TORNEO:</label></div>
          <div class="col-8"><label [ngStyle]="{'color':campeonato.configuracion_tarjeta_jugador.datos_color,'font-size.px': '20'}">COPA ASFINBOL</label></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modal_configuracion_pdf_rol_partido let-modal>
  <div class="modal-header card-header">
      <div class="col-md-8 col-xs-8">
          <span class="text-blue text-125">Imágenes para redes del rol</span>
          <div class="text-grey text-90">{{campeonato.nombre}} · de 2 a 8 partidos por imagen</div>
      </div>
      <div class="col-md-4 col-xs-4 text-right">
          <button (click)="guardarConfiguracionPdfRolPartido()" class="btn btn-primary" title="Guardar">
              <i class="fa fa-save text-110 mr-1"></i>
          </button>&nbsp;
          <button class="btn btn-danger" type="button" title="Cerrar sin guardar" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
    <div class="row">
      <!-- en el celular la vista previa va arriba, asi se ve el efecto de cada cambio sin bajar -->
      <div class="col-12 col-lg-4 order-2 order-lg-1 config-rol-controles">

        <div class="config-rol-grupo">
          <div class="config-rol-titulo">Diseño</div>
          <select class="form-control" name="usar_version_rol" [(ngModel)]="configuracion_pdf_rol.usar_rol_version" (ngModelChange)="programarVistaPreviaRol()">
            <option [ngValue]="version.version" *ngFor="let version of versiones_rol_partido">{{version.nombre}}</option>
          </select>
        </div>

        <div class="config-rol-grupo">
          <div class="config-rol-titulo">Mostrar</div>
          <div class="text-grey text-85 mb-1">Categoría, disciplina y campeonato propio también se aplican al PDF del rol completo.</div>
          <label class="config-rol-switch">
            <span>Categoría</span>
            <input name="mostrar_categoria" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="configuracion_pdf_rol.mostrar_categoria" (ngModelChange)="programarVistaPreviaRol()"/>
          </label>
          <label class="config-rol-switch">
            <span>Disciplina</span>
            <input name="mostrar_disciplina" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="configuracion_pdf_rol.mostrar_disciplina" (ngModelChange)="programarVistaPreviaRol()"/>
          </label>
          <label class="config-rol-switch">
            <span>Escenario</span>
            <input name="mostrar_escenario" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="configuracion_pdf_rol.mostrar_escenario" (ngModelChange)="programarVistaPreviaRol()"/>
          </label>
          <label class="config-rol-switch">
            <span>Campeonato propio <small class="text-grey d-block">logo de la empresa y personería en la cabecera</small></span>
            <input name="campeonato_propio" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="configuracion_pdf_rol.campeonato_propio" (ngModelChange)="programarVistaPreviaRol()"/>
          </label>
        </div>

        <div class="config-rol-grupo">
          <div class="config-rol-titulo">Otros</div>
          <label class="config-rol-switch">
            <span>Caja marcador <small class="text-grey d-block">se usa en la caja de mesa, no cambia la imagen</small></span>
            <input name="caja_marcador" class="ace-switch input-lg ace-switch-sino bgc-blue-d1" type="checkbox" [(ngModel)]="configuracion_pdf_rol.caja_marcador"/>
          </label>
        </div>
      </div>

      <div class="col-12 col-lg-8 order-1 order-lg-2 mb-3 mb-lg-0" *ngIf="vista_previa_rol">
        <div class="config-rol-barra">
          <select class="form-control form-control-sm config-rol-selector" name="rol_vista_previa" title="Rol que se usa para la vista previa"
                  [disabled]="vista_previa_rol.roles.length==0" [(ngModel)]="vista_previa_rol.rol_seleccionado" (ngModelChange)="cambiarRolVistaPrevia()">
            <option *ngIf="vista_previa_rol.roles.length==0" [ngValue]="null">Sin roles</option>
            <option *ngFor="let rol of vista_previa_rol.roles" [ngValue]="rol">{{rol.rol?.nombre}}</option>
          </select>
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn" [ngClass]="vista_previa_rol.con_resultados?'btn-outline-primary':'btn-primary'"
                    (click)="vista_previa_rol.con_resultados=false;programarVistaPreviaRol()">Rol</button>
            <button type="button" class="btn" [ngClass]="vista_previa_rol.con_resultados?'btn-primary':'btn-outline-primary'"
                    (click)="vista_previa_rol.con_resultados=true;programarVistaPreviaRol()">Resultados</button>
          </div>
          <select class="form-control form-control-sm config-rol-cantidad" name="cantidad_vista_previa" title="Cantidad de partidos de la imagen"
                  [(ngModel)]="vista_previa_rol.cantidad" (ngModelChange)="programarVistaPreviaRol()">
            <option [ngValue]="cantidad" *ngFor="let cantidad of cantidades_vista_previa">{{cantidad}} partidos</option>
          </select>
          <button type="button" class="btn btn-sm btn-outline-secondary ml-auto" title="Abrir en una pestaña nueva"
                  [disabled]="!vista_previa_rol.url_blob" (click)="abrirVistaPreviaRolEnPestana()">
            <i class="fas fa-external-link-alt"></i>
          </button>
        </div>

        <div class="config-rol-vista">
          <div class="config-rol-estado" *ngIf="vista_previa_rol.generando || vista_previa_rol.cargando_rol">
            <i class="fa fa-spinner fa-spin mr-1"></i> Actualizando…
          </div>
          <div class="config-rol-aviso" *ngIf="vista_previa_rol.mensaje">
            <i class="fas fa-info-circle text-blue mr-1"></i>{{vista_previa_rol.mensaje}}
          </div>
          <pdf-viewer *ngIf="vista_previa_rol.pdf && !vista_previa_rol.mensaje"
                      [src]="vista_previa_rol.pdf"
                      [render-text]="false"
                      [original-size]="false"
                      [show-all]="true"
                      [autoresize]="true"
                      style="display: block;"></pdf-viewer>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modal_saldo_equipos let-modal>
  <div class="modal-header card-header">
      <div class="col-10">
          <span class="text-blue text-125">Pendientes Economicos : {{campeonato.nombre}}</span>
      </div>
      <div class="col-2">
          <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
              <i class="fa fa-times red2 text-110 mr-1"></i>
          </button>
      </div>
  </div>
  <div class="modal-body card-body">
      <div *ngIf="cuentas_clientes.length==0" class="text-center text-grey-d1 py-3">No hay equipos con pendientes económicos.</div>
      <div *ngIf="cuentas_clientes.length>0" class="d-flex flex-wrap justify-content-end text-85 text-grey-d1 mb-2">
        <span *ngFor="let nivel of niveles_deuda" class="ml-3 text-nowrap">
          <i class="fas fa-circle mr-1" [style.color]="nivel.color"></i>{{nivel.nombre}}
        </span>
      </div>
      <div class="row">
          <div *ngFor="let cliente of cuentas_clientes; let i=index;" class="col-12 col-sm-6 col-lg-4 mb-3">
            <div class="card h-100 shadow-sm radius-1" [style.border-left]="'6px solid '+obtenerNivelDeuda(cliente).color">
              <div class="card-body p-2">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 text-center mr-2" style="width: 60px;">
                    <img *ngIf="cliente.logo" width="60" height="60" style="object-fit: contain;" alt="escudo" [src]="rest_server+cliente.logo" />
                    <i *ngIf="!cliente.logo" class="fas fa-shield-alt text-grey-l2" style="font-size: 50px;"></i>
                  </div>
                  <div class="flex-grow-1" style="min-width: 0;">
                    <div class="text-dark-m2 font-bolder text-105 text-truncate" [title]="cliente.identificacion">{{cliente.identificacion}}</div>
                    <div class="text-grey text-85">
                      Nº {{i+1}} · Código: {{cliente.codigo}}
                      <span *ngIf="cliente.telefono1" class="text-nowrap">
                        · <i class="fas fa-phone-alt text-success-m1"></i> {{cliente.telefono1}}
                        <a href="javascript:void(0)" class="text-blue ml-1" title="Copiar número" (click)="copiarTelefonoCliente(cliente)"><i class="fas fa-copy"></i></a>
                      </span>
                    </div>
                    <span class="badge font-bolder text-105 mt-1" [style.background-color]="obtenerNivelDeuda(cliente).color" [style.color]="obtenerNivelDeuda(cliente).color_texto" [title]="obtenerNivelDeuda(cliente).nombre">Bs {{cliente.saldo_cliente | number:'1.2-2'}}</span>
                  </div>
                </div>
                <div *ngIf="cliente.mostrar_ventas_pendientes" class="bgc-orange-l4 radius-1 p-2 mt-2">
                  <div *ngIf="cliente.ventas_pendientes.length==0" class="text-grey-d1 text-90">El equipo no tiene ventas pendientes.</div>
                  <div *ngFor="let venta of cliente.ventas_pendientes" class="d-flex justify-content-between align-items-center text-90 border-b-1 brc-orange-l2 py-1">
                    <div class="pr-2" style="min-width: 0;">
                      <div *ngFor="let detalle of venta.detalles">{{detalle.producto.nombre}}{{detalle.descripcion?' '+detalle.descripcion:''}}</div>
                      <div class="text-grey text-85">
                        {{venta.fecha | date:'dd/MM/yyyy'}}
                        <span *ngIf="venta.a_cuenta>0"> · A cuenta Bs {{venta.a_cuenta | number:'1.2-2'}}</span>
                      </div>
                    </div>
                    <div class="text-right">
                      <div class="text-nowrap font-bolder">Bs {{venta.saldo | number:'1.2-2'}}</div>
                      <div class="text-nowrap">
                        <a class="btn radius-1 btn-xs btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success px-1" href="javascript:void(0)" title="Pagar a cuenta" (click)="abrirPagoVentaPendiente(cliente,venta)">
                          <i class="fa fa-money-bill-alt text-105"></i>
                        </a>
                        <a *ngIf="!(venta.a_cuenta>0)" class="btn radius-1 btn-xs btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger px-1" href="javascript:void(0)" title="Anular venta" (click)="abrirAnulacionVentaPendiente(cliente,venta)">
                          <i class="fa fa-trash-alt text-105"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bgc-white p-1 text-center">
                <div class="action-buttons">
                  <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-warning btn-a-outline-warning btn-text-warning" href="javascript:void(0)" title="Ver ventas pendientes" (click)="verVentasPendientesCliente(cliente)">
                    <i class="fas text-105" [ngClass]="cliente.mostrar_ventas_pendientes?'fa-eye-slash':'fa-eye'"></i>
                  </a>
                  <a *ngIf="usuario.empresa.usar_mensajeria_redes_sociales" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" type="button" title="Enviar mensaje por whatsapp" (click)="enviarPendientesEconomicosEquipo({cliente:cliente,nombre:cliente.identificacion})">
                    <i class="fab fa-whatsapp red2 text-110"></i>
                  </a>
                  <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" title="Copiar mensaje de deudas" (click)="copiarPendientesEconomicosEquipo({cliente:cliente,nombre:cliente.identificacion})">
                    <i class="fas fa-clipboard text-105"></i>
                  </a>
                  <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-primary btn-a-outline-primary btn-text-primary" href="javascript:void(0)" title="Estado de cuenta" (click)="abrirEstadoCuentaCliente(cliente)">
                    <i class="fa fa-filter text-105"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</ng-template>
<!-- Enlace de la venta de inscripcion con el equipo. Hace falta para los equipos que se cobraron
     antes de que existiera la referencia: el usuario dice cual venta era de este equipo. -->
<ng-template #modal_inscripcion_equipo let-modal>
    <div class="modal-header card-header">
        <div class="col-md-9 col-xs-8">
            <span class="text-blue text-125">Inscripción de {{equipo_inscripcion.nombre}}</span>
            <span class="text-grey text-90 ml-1">{{equipo_inscripcion.categoria?equipo_inscripcion.categoria.nombre:''}}</span>
        </div>
        <div class="col-md-3 col-xs-4 text-right">
            <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 text-110 mr-1"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
      <div *ngIf="tieneInscripcionCobrada(equipo_inscripcion)" class="alert alert-success py-2">
        Este equipo está enlazado a la nota de venta
        <b>{{equipo_inscripcion.venta_inscripcion.factura}}</b>
        de {{equipo_inscripcion.venta_inscripcion.total}} Bs, saldo {{equipo_inscripcion.venta_inscripcion.saldo}} Bs.
        <a href="javascript:void(0)" class="text-danger ml-2" (click)="enlazarVentaInscripcion(null)">
          <i class="fa fa-unlink mr-1"></i>Quitar el enlace
        </a>
      </div>

      <div class="text-grey text-90 mb-2">
        Inscripciones registradas a nombre de <b>{{equipo_inscripcion.cliente.razon_social}}</b>
        que todavía no están asignadas a ningún equipo:
      </div>

      <table *ngIf="ventas_inscripcion.length>0" class="table table-sm table-bordered table-hover text-95">
        <thead class="bgc-white text-grey text-uppercase text-80">
          <tr>
            <th>Nota</th><th>Fecha</th><th>Concepto</th><th class="center">Total</th><th class="center">Saldo</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let venta of ventas_inscripcion">
            <td>{{venta.factura}}</td>
            <td>{{venta.fecha | date:'dd/MM/yyyy'}}</td>
            <td>
              <ng-container *ngFor="let detalle of venta.detallesVenta">
                {{detalle.producto.nombre}}
                <span *ngIf="detalle.descripcion" class="text-grey">({{detalle.descripcion}})</span><br>
              </ng-container>
            </td>
            <td class="center">{{venta.total}}</td>
            <td class="center">{{venta.saldo}}</td>
            <td class="center">
              <button type="button" class="btn btn-sm btn-success" (click)="enlazarVentaInscripcion(venta)">
                <i class="fa fa-link mr-1"></i>Es de este equipo
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="ventas_inscripcion.length==0" class="text-center text-grey py-3">
        El cliente no tiene inscripciones libres para enlazar.
      </div>

      <div class="text-right mt-2">
        <button type="button" class="btn btn-primary" (click)="cobrarInscripcionNueva()">
          <i class="fas fa-file-invoice-dollar mr-1"></i>Cobrar una inscripción nueva
        </button>
      </div>
    </div>
</ng-template>
